module.exports = __webpack_public_path__ + "img/20250917_1.4d4cf451.png";